import styled from "styled-components";
import Title from "../../../common/Title";
import Division from "../../../common/Division";
import SkillBox from "../../../common/SkillBox";
import Content from "../../../common/Content";
import Accordion from "../../../common/Accordion";
import ListItem from "../../../common/ListItem";
import ProjectLinkBox from "../../../common/ProjectLinkBox";
import ProjectLink from "../../../common/ProjectLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import tanstack from "../../../../assets/img/new/tanstack-white.svg";

const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export default function PortfolioBox() {
  return (
    <Box>
      <Title>포트폴리오</Title>
      <Division>개인 프로젝트</Division>
      <SkillBox
        skill={[
          { logo: "React", content: "리액트(React)", color: "61DAFB" },
          {
            logo: "tanstack",
            content: "TanStack Query",
            color: "000000",
            img: tanstack,
          },
          {
            logo: "styledcomponents",
            content: "Styled-components",
            color: "DB7093",
          },
          {
            logo: "TypeScript",
            content: "타입스크립트(TypeScript)",
            color: "3178C6",
            division: true,
          },
          {
            logo: "firebase",
            content: "Firebase Hosting",
            color: "FFCA28",
            division: true,
          },
          {
            logo: "firebase",
            content: "Firebase Cloud Firestore",
            color: "FFCA28",
          },
        ]}
      />
      <Content>
        <Accordion title="개요" open={true}>
          React 를 기반으로 개발된 저의 포트폴리오 사이트입니다. 개발자로서의
          경험, 활용 가능한 기술 스택, 그리고 지금까지 진행해 온 다양한
          프로젝트들을 소개하기 위해 제작되었습니다.
        </Accordion>
        <Accordion title="주요 기능 및 역할" open={true}>
          <ListItem>
            이력 사항을 정리해 주요 정보를 한눈에 확인할 수 있도록 제공합니다.
          </ListItem>
          <ListItem>
            경력과 자격증 취득 내역을 소개하여, 개발 경험과 전문성을 전달합니다.
          </ListItem>
          <ListItem>
            참여했던 프로젝트를 소개하며, 각 프로젝트에서 맡았던 역할과 구현한
            기능을 소개합니다.
          </ListItem>
          <ListItem>
            Firebase Firestore를 활용해 방문자 수 데이터를 기록하고, 이를
            그래프로 시각화하여 제공합니다.
          </ListItem>
        </Accordion>
      </Content>
      <ProjectLinkBox>
        <ProjectLink href="/" title="Home">
          <FontAwesomeIcon icon={faHouse} />
        </ProjectLink>
        <ProjectLink
          href="https://github.com/Leewonno/portfolio"
          title="Github"
        >
          <FontAwesomeIcon icon={faGithub} />
        </ProjectLink>
      </ProjectLinkBox>
    </Box>
  );
}
